import React from 'react';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import { Paper, Typography, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import './ProjectActivityFeed.css';

const getIconByModelType = (modelType) => {
  switch (modelType?.toLowerCase()) {
    case 'submission':
      return <DescriptionIcon fontSize="small" />;
    case 'user':
      return <PersonIcon fontSize="small" />;
    case 'project':
      return <FolderIcon fontSize="small" />;
    case 'review':
      return <AssignmentIcon fontSize="small" />;
    default:
      return <HelpOutlineIcon fontSize="small" />;
  }
};

export default function ProjectActivityFeed({ logs }) {
  const filteredLogs = logs
    .filter((log) => log.type === 'COMPLETE')
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
console.log('Filtered ProjectActivityFeed logs:', filteredLogs);
  return (
  <div className="project-feed">
    <Timeline position="alternate"  className="project-feed-timeline">
      {filteredLogs.map((log) => (
        <TimelineItem key={log.id}>
          <TimelineOppositeContent sx={{ flex: 0.15 }} className="project-feed-time">
            <Typography variant="body2" color="grey.500">
              {new Date(log.createdAt).toLocaleString()}
            </Typography>
          </TimelineOppositeContent>

          <TimelineSeparator>
            <TimelineDot className="project-feed-dot">
              {getIconByModelType(log.modelType)}
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>

          <TimelineContent sx={{ py: 1 }}>
            <Paper elevation={3} sx={{ px: 2, py: 1, maxWidth: 480 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                {log.category?.replace(/_/g, ' ') || 'Unknown Event'}
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {log.description || ''}
              </Typography>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
    </div>
  );
}
